//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext,useCallback } from "react";

// custom pages
import Table from "components/Table/Table";
import ShiptoDetailsAPI from "apis/shiptoDetails/shiptoDetails";
import Context from "context/context";
import searchIcon from "assets/img/Search_Icon.png";
import { Styles } from "./styles";
import useDebounce from "helpers/useDebounce";

// material-ui
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import MenuItem from "@material-ui/core/MenuItem";
import Card from "@material-ui/core/Card";
import Badge from "@material-ui/core/Badge";
import { toast } from "react-toastify";
import * as moment from "moment";
import { CSVLink } from 'react-csv';
// material-ui icons
import Grid from "@material-ui/core/Grid";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { blockInvalidChar } from "helpers/blockInvalidChar";
import Button from "@material-ui/core/Button";
import { exportHeaders } from "./export";



import { useTranslation } from 'react-i18next';
// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
        background: "#ededed",
      },
    },
  },
})(TextField);

export default function ShiptoDetails() {
  const { getAPI, searchAPI, getThriveSegmentationAPI,shiptoDetailsFilter,shiptoExport } = ShiptoDetailsAPI();
  const { state, dispatch } = useContext(Context);
  const classes = Styles();
  const [data, setData] = useState([]);
  const [thriveSegmentation, setThriveSegmentation] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [fitervalue, setfiterValue] = useState("");
  const [exportData, setExportData] = useState([]);
  const [response, setResponse] = useState({
    filter: false,
  });
  const [filterCard, setFilterCard] = useState(false);
  

  const [states, setstates] = useState({
    filter: false,
    salesCategory: "",
    redemptionFrom: null,
    redemptionTo: null,
    enrolable: "No",
    orderBy: "negative_count",
    orgName: "",
    isActive: "",
    historyLoader: false,
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);


  const searchBounceValues = useDebounce(searchValue);
  const{t, i18n}= useTranslation()
  useEffect(() => {
    if (searchBounceValues && searchBounceValues.length > 0) {
      handleSearch();
    } else if(states.filter){
      
    handleFilter()
    }
    else {
      getUserDetails();
    }
  }, [searchBounceValues, offset]);

  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Shipto Details"],
    });
    handleGetThriveSegmentation();
  }, []);

  async function handleGetThriveSegmentation() {
    try {
      let res = await getThriveSegmentationAPI();
      if (res && res?.data) {
        setThriveSegmentation(res.data);
      }
    } catch (e) {
      console.log({ e });
    }
  }

  async function getUserDetails() {
    try {
      setLoading(true);
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };

      dispatch({ type: "SET_LOADING", payload: true });
      let res = await getAPI(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setResponse({ filter: false });
        setLoading(false);
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  }

  async function handleSearch() {
    try {
      setLoading(true);
      let values;
      values = {
        search: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,
      };

      dispatch({ type: "SET_LOADING", payload: true });
      let res = await searchAPI(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setResponse({ filter: false });
        setLoading(false);
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  }
  const handleFilter = async () => {
    setStates({ filter: true });
    setSearchValue("");
    try {
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
        enrollable: states.enrolable,
      };
    
      dispatch({ type: "SET_LOADING", payload: true });
      console.log(values,"values")
      let res = await shiptoDetailsFilter(values);
      // // console.log(res,"hhhhhh")
      if (res) {
        setData(res.data);
        setCount(res.count);
        setFilterCard(false);
        setResponse({ filter: true });
        dispatch({ type: "SET_LOADING", payload: false });
      } else {
        setFilterCard(false);
      }
    } catch (e) {
      console.log({ e });
    }
  };
  let tableHeading = [
    "Shipto",
    "Billto",
    "Shipto Name",
    "Type Code",
    "Status",
    "Sales Division",
    "Market Class",
    "Segment",
    "Qualified Flag",
    "Enrollable",
  ];

  const handlePagination = (value) => {
    setOffset(value);
  };

  const handleExport = async () => {
    setLoading(true)
  
    let values = {};
// Conditionally add filterValue
    if (states.enrolable && states.filter) {
      values = { ...values, filtervalue:states?.enrolable };
    }
    
    
    if (searchValue) {
      values = { ...values, searchValue };
    }

    dispatch({ type: "SET_LOADING", payload: true });
    let res = await shiptoExport(values);
    console.log(res,"ragav")
    if (res && res.data) {
      setLoading(false)
      
        setExportData(res.data.map((d) => {
          return {
            ...d,
          type: d?.type === "ENROLLED" ?            
              d?.type[0] + d?.type?.slice(1).toLowerCase()            
           : thriveSegmentation?.filter(
              (t) =>
                t.customer_sales_division_code ==
                  d?.customer_sales_division_code &&
                t.market_class_code == d?.market_class_code &&
                (t.segment_code === d?.segment_code ||
                  (!t.segment_code && !d.segment_code))
            )?.length > 0 &&
            (d?.customer_status_code === "A" ||
              d?.customer_status_code === "N") &&
            d?.qualified_account_flag ? 
            'Yes'
           : 
            'No'
                }
          
          
        }));
        
        dispatch({ type: "SET_LOADING", payload: false });
       
        if (res.data.length === 0) {
          toast.success(t("No Data Found"), { toastId: "no-report-date" });
          return false;
        }
       
        return true;
      }
    }

  return (
    <>
      <Grid 
       container
       spacing={0}
       onClick={() => {
         filterCard == true && setFilterCard(false);
       }}>
        <CssTextField
          id="enterPassword"
          placeholder={t('Search for Shipto')}
          onKeyDown={blockInvalidChar}
          type={"number"}
              onWheel={(e) => e.target.blur()}
          variant="outlined"
          autoComplete="off"
          className={classes.searchInput}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {searchValue.length > 0 ? (
                  <CloseOutlinedIcon
                    className={classes.searchInputIcon}
                    onClick={() => {
                      setSearchValue("");
                      setOffset(1);
                      getUserDetails();
                    }}
                  />
                ) : (
                  <img
                    src={searchIcon}
                    alt=""
                    width="20px"
                    className={classes.searchInputIcon}
                  />
                )}
              </InputAdornment>
            ),
          }}
          value={searchValue}
          onChange={(e) => {
            e.target.value.replace(/\s+/g, "").length == 0
              ? setSearchValue("")
              : setSearchValue(e.target.value);
            if (e.target.value.length == 0) {
              getUserDetails();
            }
          }}
          onClick={() => {
            setOffset(1);
          }}
        />
          <Button
              className={`${classes.filterBtn} dash-1-filter-btn`}
              onClick={() => {
                setFilterCard(!filterCard);
                

            
             
                if (!states.filter) {
                  setStates({
                    expired: "",
                    startDate: null,
                    endDate: null,
                    type: [],
                    reason: "",

                  });
                }
              }}
              // onChange={(e) => {
              //   setfiterValue(e.target.value)
              // }}
            >
              {t('Filter')}
              {response["filter"] && (
                <Badge
                  badgeContent={count == 0 ? null : response["filter"] && count}
                  color="error"
                  classes={{ badge: classes.badge }}
                  max={999999}
                  className={classes.badges}
                ></Badge>
              )}
            </Button> 
            <CSVLink
            id="csv"
            data={exportData
               }
             headers={exportHeaders}
         filename={
              `Shipto-Details` +
              " " +
              moment(new Date()).format("MM-DD-YYYY,h:mm A") +
              ".csv"
            }
            className={classes.CSVlink}
          />
                <button
            // disabled={isLoading}
            className={classes.exportBtn1}
            onClick={async () => {
              let res = await handleExport();
              if (res) {
                document.getElementById("csv").click();
              }
            }}
          >
            {t('Export')}
          </button>
      </Grid>
      {filterCard && (
        <div className={classes.filterCardDiv}>
          <Grid container spacing={0}>
            <Grid item xs={12} style={{ float: "right" }}>
              <Card className={classes.filterCard}>
                <Grid
                  container
                  spacing={2}
                  className={classes.filterCardGridContainer}
                >                      
                  <Grid item sm={6} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>Enrollable</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.enrolable}
                      onChange={(e) => {
                        setStates({ enrolable: e.target.value });
                      }}
                    >
                      <MenuItem value={"No"}>No</MenuItem>
                      <MenuItem value={"Yes"}>Yes</MenuItem>
                      <MenuItem value={"Enrolled"}>Enrolled</MenuItem>
                      
                    </TextField>
                  </Grid>                      
                  <Grid item sm={6} xs={12} className={classes.filterCardBtnGrid}                      >
                    <Grid container spacing={0}>
                      <Grid item xs={12}>
                        <Button
                          className={classes.filterCardApplyBtn}
                          onClick={() => {                                
                            handleFilter();
                            setCount(0);
                            setOffset(1);
                            setResponse({ filter: false });
                          }}
                        >
                          {t('Apply')}
                        </Button>
                      </Grid>
                      {states.filter && (
                        <Grid item xs={12}>
                          <Button
                            className={classes.filterCardResetBtn}
                            onClick={() => {
                              setStates({
                                filter: false,
                                type: "",
                                enrolable:"No",
                                editObj: "",
                                updateObj: ""
                              });
                              setOffset(1);
                              setFilterCard(false);
                              getUserDetails();
                              setCount(0);
                              setResponse({ filter: false });
                            }}
                          >
                            {t('Reset')}
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </div>
      )}

      <div style={{ marginTop: 20 }}>
        {!loading ? (
          <Table
            headings={tableHeading.map((i) => {
              return <div key = {t(i)}>{t(i)}</div>;
            })}
            data={
              data &&
              data.length > 0 &&
              data.map((d) => [
                d?.customer_account_number,
                d?.customer_billto_account_number,
                d?.customer_name,
                d?.customer_account_type_code,
                d?.customer_status_code === "A" ||
                d?.customer_status_code === "N" ? (
                  <span>
                    {d?.customer_status_code}&nbsp;
                    <CheckCircleIcon className={classes.matchedValue} />
                  </span>
                ) : (
                  <span>
                    {d?.customer_status_code}&nbsp;
                    <HighlightOffIcon className={classes.unMatchedValue} />
                  </span>
                ),
                thriveSegmentation?.filter(
                  (t) =>
                    t.customer_sales_division_code ===
                    d?.customer_sales_division_code
                )?.length > 0 ? (
                  <span>
                    {d?.customer_sales_division_code
                      ? d?.customer_sales_division_code
                      : "(Empty)"}
                    &nbsp;
                    <CheckCircleIcon className={classes.matchedValue} />
                  </span>
                ) : (
                  <span>
                    {d?.customer_sales_division_code
                      ? d?.customer_sales_division_code
                      : "(Empty)"}
                    &nbsp;
                    <HighlightOffIcon className={classes.unMatchedValue} />
                  </span>
                ),
                thriveSegmentation?.filter(
                  (t) => t.market_class_code === d?.market_class_code
                )?.length > 0 ? (
                  <span>
                    {d?.market_class_code ? d?.market_class_code : "(Empty)"}
                    &nbsp;
                    <CheckCircleIcon className={classes.matchedValue} />
                  </span>
                ) : (
                  <span>
                    {d?.market_class_code ? d?.market_class_code : "(Empty)"}
                    &nbsp;
                    <HighlightOffIcon className={classes.unMatchedValue} />
                  </span>
                ),
                thriveSegmentation?.filter(
                  (t) =>
                    t.segment_code == d?.segment_code ||
                    (!t.segment_code && !d.segment_code)
                )?.length > 0 ? (
                  <span>
                    {d?.segment_code ? d?.segment_code : "(Empty)"}&nbsp;
                    <CheckCircleIcon className={classes.matchedValue} />
                  </span>
                ) : (
                  <span>
                    {d?.segment_code ? d?.segment_code : "(Empty)"}&nbsp;
                    <HighlightOffIcon className={classes.unMatchedValue} />
                  </span>
                ),
                d?.qualified_account_flag ? (
                  <span>
                    {t('Yes')} <CheckCircleIcon className={classes.matchedValue} />
                  </span>
                ) : (
                  <span>
                    {t('No')} <HighlightOffIcon className={classes.unMatchedValue} />
                  </span>
                ),
                d?.type === "ENROLLED" ? (
                  <span className={classes.enrolledBtn}>
                    {d?.type[0] + d?.type?.slice(1).toLowerCase()}
                  </span>
                ) : thriveSegmentation?.filter(
                    (t) =>
                      t.customer_sales_division_code ==
                        d?.customer_sales_division_code &&
                      t.market_class_code == d?.market_class_code &&
                      (t.segment_code === d?.segment_code ||
                        (!t.segment_code && !d.segment_code))
                  )?.length > 0 &&
                  (d?.customer_status_code === "A" ||
                    d?.customer_status_code === "N") &&
                  d?.qualified_account_flag ? (
                  <span className={classes.yesBtn}>{t('Yes')}</span>
                ) : (
                  <span className={classes.noBtn}>{t('No')}</span>
                ),
              ])
            }
            offset={offset}
            count={
              (count / 10) % 1 == 0
                ? Math.floor(count / 10)
                : Math.floor(count / 10 + 1)
            }
            handlePagination={handlePagination}
          />
        ) : (
          <div
            style={{
              height: "25vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h2>{t('Loading...')}</h2>
          </div>
        )}
      </div>
    </>
  );
}
